import { toApiError } from '@/lib/agentApiServices/utils'
import type { ApiClient, ApiService } from '@/lib/apiClient'
import { formatDateISO } from '@/utils/date'

interface Args {
  startDate: Date
  endDate: Date
  userId: string
  customerId: string
}

type Response = Blob

export type GetCompletedActivitiesforUserCsvApiService = ApiService<Args, Response>

type GetCompletedActivitiesForUserCsvUrlArgs = {
  customerId: string
  userId: string
  startDate: Date
  endDate: Date
}

const toEncodedIsoDate = (date: Date): string => encodeURIComponent(formatDateISO(date))

export const getCompletedActivitiesForUserCsvUrl = ({
  startDate,
  endDate,
  userId,
  customerId,
}: GetCompletedActivitiesForUserCsvUrlArgs): string =>
  `dashboard/completed-activities/csv?startDate=${toEncodedIsoDate(
    startDate,
  )}&endDate=${toEncodedIsoDate(endDate)}&userId=${userId}&customerId=${customerId}`

const createGetCompletedActivitiesForUserCsvApiService =
  (apiClient: ApiClient): GetCompletedActivitiesforUserCsvApiService =>
  ({ startDate, endDate, userId, customerId }) =>
    apiClient
      .get(
        getCompletedActivitiesForUserCsvUrl({
          startDate,
          endDate,
          userId,
          customerId,
        }),
      )
      .then(({ data }) => data)
      .catch(error => Promise.reject(toApiError(error)))

export default createGetCompletedActivitiesForUserCsvApiService
